const BaseSearchMode = {
	REGULAR: 'regular',
	IMAGE: 'image',
} as const;

const SearchModeEnum = {
	...BaseSearchMode,
	COLOR: 'color',
} as const;

export const UISearchModeEnum = BaseSearchMode;

export type UISearchModeType = ValueOf<typeof UISearchModeEnum>;
export type SearchModeType = ValueOf<typeof SearchModeEnum>;

export default SearchModeEnum;
